import { render, staticRenderFns } from "./ModalVideoPlaceHolder.vue?vue&type=template&id=70a5f756&scoped=true&"
import script from "./ModalVideoPlaceHolder.vue?vue&type=script&lang=js&"
export * from "./ModalVideoPlaceHolder.vue?vue&type=script&lang=js&"
import style0 from "./ModalVideoPlaceHolder.vue?vue&type=style&index=0&id=70a5f756&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a5f756",
  null
  
)

export default component.exports